__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/2adacd26c7353eff8ed2f281ca2fb4429e42de16/_next/";